import React from "react";
import { Link, useNavigate } from 'react-router-dom';

const Educations = (props) => {

    return (
        <div className="container contents-wrapper">
            <div className="contents-wrapper-width">
                <h1 className="page-title">학습</h1>

            </div>
        </div>
    );
}
export default Educations;